/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';
import { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import TypographyTooltip from 'src/components/typography-tooltip';
import { useBookingRequestAction } from 'src/hooks/use-booking-request-action';

import { get } from 'lodash';
import {
  setBookingRequestPopoverFocus,
  setPushNewToBookingRequest
} from 'src/layouts/dashboard/booking-notice-button/booking-notice.slice';
import { tabs } from 'src/layouts/dashboard/booking-notice-button/ultis';
import { formatDateUTC } from 'src/utils/parse';
import CircleColor from '../circle-color';
import LicensePlate from '../license-plate';
import BookingWrapMessage from './booking-wrap-message';
import LicensePlateColor from '../license-plate-color';
const BookingRequestNewNotice = ({ toastId, content }) => {
  console.log('BookingRequestNewNotice content', content);
  const dispatch = useDispatch();

  const { handleConfirm } = useBookingRequestAction();
  const requestAt = formatDateUTC(content.updatedAt, 'MMM dd, h:mm a');
  const requestCar = get(content, 'requestCar');

  const onConfirm = (id, value) => {
    toast.dismiss(toastId);
    handleConfirm(id, value);
  };

  const openRequestNoticeFocus = useCallback((requestId) => {
    dispatch(
      setBookingRequestPopoverFocus({
        tab: tabs.requestNew.value,
        requestId
      })
    );
    toast.remove(toastId);
  }, []);

  useEffect(() => {
    if (toastId) {
      dispatch(setPushNewToBookingRequest(content));
    }
  }, [toastId, content]);

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'primary.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={1}>
              <Typography
                sx={{ mr: 0.5, cursor: 'pointer' }}
                variant="subtitle1"
                {...(toastId && {
                  onClick: () => {
                    openRequestNoticeFocus(content.id);
                  }
                })}
              >
                {content.tagKey}
              </Typography>

              <Typography
                variant="body2"
                fontWeight="bold"
                color="warning.main"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={(event) => {
                  event.stopPropagation();
                  onConfirm(content.id, true);
                }}
              >
                Nhận kèo
              </Typography>
            </Stack>
            {requestCar && (
              <BookingWrapMessage borderColor="warning.main">
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Xe :</Typography>
                  <Typography variant="subtitle2" color="primary.main">
                    {requestCar?.model?.name} {` (${requestCar.inServiceYear})`}
                  </Typography>
                </Stack>
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Biển số :</Typography>
                  <LicensePlateColor licensePlate={requestCar.licensePlate} color={requestCar.color} />
                </Stack>
              </BookingWrapMessage>
            )}

            <BookingWrapMessage>
              <TypographyTooltip mixText={content.message} maxLines={5} variant="body2" />
            </BookingWrapMessage>
            {/* 
                  <Typography sx={{ mr: 0.5 }} variant="body2">
                    {request.message}
                  </Typography> */}
          </Box>
        }
        secondary={
          <Stack direction="row" justifyContent="space-between" alignItems="center" mt={1}>
            <Typography color="text.secondary" variant="caption">
              {requestAt}
            </Typography>
            <Typography
              variant="body2"
              fontWeight="bold"
              color="grey.700"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                onConfirm(content.id, false);
              }}
            >
              Bỏ qua
            </Typography>
          </Stack>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingRequestNewNotice;
